import { useEffect, useState } from "react";
import { Stack, Typography, Button } from "@mui/material";
import { Drawer } from "../../Drawer";
import { shipmentLogsColumnsData } from "./ShipmentLogsTable/ShipmentsLogsColumndata";
import { ColDef } from "ag-grid-community";
import { globalTheme } from "../../../styles";
import { ShipmentsLogsTable } from "./ShipmentLogsTable/ShipmentsLogsTable";

interface ShipmentsLogsDrawerProps {
  open: boolean;
  onClose: () => void;
  onValidation: () => void;
  shipmentLogsData: IOrderShipmentLogs[];
  orderId: string;
}

export const ShipmentsLogsDrawer = ({ open, onClose, shipmentLogsData, orderId }: ShipmentsLogsDrawerProps) => {
  const [rowData, setRowData] = useState<IOrderShipmentLogs[]>([]);
  const [columnDefs, _setColumnDefs] = useState<ColDef[]>(shipmentLogsColumnsData);

  useEffect(() => {
    if (shipmentLogsData) {
      setRowData(shipmentLogsData);
    } else {
      setRowData([]);
    }
  }, [shipmentLogsData]);

  return (
    <Drawer open={open} onClose={onClose}>
      <Stack spacing={2} margin={2}>
        <Typography
          variant="subtitle2"
          component="span"
          sx={{
            backgroundColor: globalTheme.background,
            color: globalTheme.primaryColor,
            p: 1,
            borderRadius: 2,
            width: "fit-content",
          }}
        >
          OrderID: {orderId}
        </Typography>

        <ShipmentsLogsTable rowData={rowData} columnDefs={columnDefs} />
      </Stack>
    </Drawer>
  );
};
